import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const ToolField = ({ field, value, onChange }) => (
  <div className="space-y-2">
    <Label className="text-sm font-medium text-[#1E1A17]">{field.label}</Label>
    {field.type === "select" ? (
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={`tool-field-${field.name}`} className="h-11 bg-white"><SelectValue /></SelectTrigger>
        <SelectContent>
          {field.options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
        </SelectContent>
      </Select>
    ) : (
      <Input data-testid={`tool-field-${field.name}`} required value={value} placeholder={field.placeholder}
        onChange={(e) => onChange(e.target.value)} className="h-11 bg-white" maxLength={300} />
    )}
  </div>
);
